import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSessionTeachers } from "../../redux/sessionSlice";

const TeacherListModal = ({ isOpen, onClose, sessionId, sessionName }) => {
  const dispatch = useDispatch();
  const { sessionTeachers, status } = useSelector((state) => state.sessions);
  
  const [teachers, setTeachers] = useState([]);

  useEffect(() => {
    if (isOpen && sessionId) {
      dispatch(getSessionTeachers(sessionId));
    }
  }, [isOpen, sessionId, dispatch]);

  useEffect(() => {
    if (sessionTeachers[sessionId]) {
      setTeachers(sessionTeachers[sessionId]);
    }
  }, [sessionTeachers, sessionId]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-2xl max-h-[80vh] overflow-hidden">
        <div className="flex justify-between items-center p-4 border-b bg-[#241763] text-white">
          <h2 className="text-lg font-semibold">
            Teachers for "{sessionName}"
          </h2>
          <button 
            onClick={onClose} 
            className="text-white hover:text-gray-200 text-2xl font-bold"
          >
            ×
          </button>
        </div>
        
        <div className="p-4">
          {status === "loading" ? (
            <div className="text-center py-8">
              <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-[#241763]"></div>
              <p className="mt-2 text-gray-600">Loading teachers...</p>
            </div>
          ) : teachers && teachers.length > 0 ? (
            <div className="space-y-3">
              <div className="bg-gray-50 p-3 rounded-lg">
                <p className="text-sm text-gray-600 mb-2">
                  Total Teachers: <span className="font-semibold text-[#241763]">{teachers.length}</span>
                </p>
              </div>
              
              <div className="max-h-96 overflow-y-auto">
                <div className="grid gap-3">
                  {teachers.map((teacher, index) => (
                    <div 
                      key={teacher.id || index} 
                      className="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow"
                    >
                      <div className="flex items-center justify-between">
                        <div className="flex-1">
                          <div className="flex items-center space-x-3">
                            <div className="w-10 h-10 bg-[#241763] rounded-full flex items-center justify-center text-white font-semibold">
                              {teacher.teacherEmail?.charAt(0).toUpperCase() || 'T'}
                            </div>
                            <div>
                              <p className="font-medium text-gray-900">
                                {teacher.teacherEmail}
                              </p>
                              <p className="text-sm text-gray-500">
                                Teacher Email
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="text-right">
                          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                            Assigned
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ) : (
            <div className="text-center py-8">
              <div className="text-gray-400 text-6xl mb-4">👥</div>
              <p className="text-gray-500 text-lg">No teachers assigned to this session</p>
              <p className="text-gray-400 text-sm mt-2">
                Click "Edit Session" to assign teachers
              </p>
            </div>
          )}
        </div>
        
        <div className="flex justify-end p-4 border-t bg-gray-50">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-[#241763] text-white rounded hover:bg-[#1a0f4a] transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default TeacherListModal;
